import { Component, ReactElement } from "react";
import Logger from "../../util/logger";

type ErrorBoundaryProps = typeof ErrorBoundary.defaultProps & {
  fallback: ReactElement ;
};
interface ErrorBoundaryState {
  hasError: boolean;
}

const logger = Logger("error-boundary");
class ErrorBoundary extends Component< ErrorBoundaryProps , ErrorBoundaryState> {
  static defaultProps = {
    fallback: <></>,
  };
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  };

  componentDidCatch(error: Error) {
    logger.error(error);
  };

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    };

    return this.props.children;
  };
};
export default ErrorBoundary;
